// extracted by mini-css-extract-plugin
export default {"blocklogin":"Login_blocklogin__dtseX","password":"Login_password__Hop6Q","input":"Login_input__wGQcv","eye":"Login_eye__XGGLN","svg":"Login_svg__ccezf"};